<template>
  <app-header class="flex justify-between pl-5 pr-7">
    <bot-selector :default-bot-id="botId" @change="changeBot" class="w-full" />
    <operator-status-switch :bot-id="botId" class="ml-2" />
  </app-header>
</template>

<script>
import AppHeader from '@/components/common/AppHeader'
import BotSelector from '@/components/common/BotSelector'
import OperatorStatusSwitch from '@/components/common/OperatorStatusSwitch'

export default {
  name: 'AppHeaderBotControl',

  components: {
    AppHeader,
    BotSelector,
    OperatorStatusSwitch
  },

  props: {
    botId: {
      type: String,
      required: true
    }
  },

  methods: {
    changeBot(bot) {
      this.$emit('change-bot', bot)
    }
  }
}
</script>
